import tickIcon from "../../../../../assets/images/feedback/check-mark.svg";
import wrongIcon from "../../../../../assets/images/feedback/wrong-icon.svg";
export const codingTable = {
    APPROACH : {
        width:'25%',
        text : "Approach",
        apiKey : "approach_shared",
        imgType: "unicode",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"15px", textIndent:'-15px'}
    },
    POSITIVES : {
        width:'25%',
        text : "Positives",
        apiKey : "positives",
        imgType: "icon",
        imgSrc : tickIcon,
        data : null,
        style: {paddingLeft:"25px", textIndent:'-25px'}
    },
    NEUTRALS : {
        width:'25%',
        text : "Neutral",
        apiKey : "neutrals",
        imgType: "unicode",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"15px", textIndent:'-15px'}
    },
    NEGATIVES : {
        width:'25%',
        text : "Negatives",
        apiKey : "negatives",
        imgType: "icon",
        imgSrc : wrongIcon,
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },
    
}

export const designTable = {
    POSITIVES : {
        width:'33%',
        text : "Positives",
        apiKey : "positives",
        imgType: "icon",
        imgSrc : tickIcon,
        data : null,
        style: {paddingLeft:"25px", textIndent:'-25px'}
    },
    NEUTRALS : {
        width:'33%',
        text : "Neutral",
        apiKey : "neutrals",
        imgType: "unicode",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"15px", textIndent:'-15px'}
    },
    NEGATIVES : {
        width:'33%',
        text : "Negatives",
        apiKey : "negatives",
        imgType: "icon",
        imgSrc : wrongIcon,
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },
    
}


export const indepthTable = {
    POSITIVES : {
        width:'33%',
        text : "Satisfactory responses to / Positives ",
        apiKey : "positives",
        imgType: "icon",
        imgSrc : tickIcon,
        data : null,
        style: {paddingLeft:"25px", textIndent:'-25px'}
    },
    NEUTRALS : {
        width:'33%',
        text : "Partially satisfactory responses to",
        apiKey : "neutrals",
        imgType: "unicode",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"15px", textIndent:'-15px'}
    },
    NEGATIVES : {
        width:'33%',
        text : "Unsatisfactory responses to / Negatives",
        apiKey : "negatives",
        imgType: "icon",
        imgSrc : wrongIcon,
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },
    
}
export const ResumeTable = {
    EXPERIENCE : {
        width:'33%',
        text : "Experience",
        apiKey : "",
        imgType: "hiphen",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },
    TECH_STACK : {
        width:'33%',
        text : "Tech Stack Knowledge",
        apiKey : "",
        imgType: "hiphen",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },    
    PROJECTS : {
        width:'33%',
        dataType:'multi-array',
        text : "Relevant Projects",
        apiKey : "",
        imgType: "",
        imgSrc : '',
        data : null,
        style: {paddingLeft:"30px", textIndent:'-20px'}
    },
}

export const ResumeTableV3 = {
    EXPERIENCE : {
        width:'33%',
        text : "Experience",
        apiKey : "",
        imgType: "hiphen",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },
    RESUME_DISCUSSION : {
        width:'66%',
        dataType:'multi-array',
        text : "Resume Discussion",
        apiKey : "",
        imgType: "",
        imgSrc : "",
        data : null,
        style: {paddingLeft:"20px", textIndent:'-18px'}
    },
}
export const codeBoxHeading = {
    CODING : "CODING QUESTIONS",
    THEORY : "",
}
export const notGuideTitle = "None (If your question is not available in the Guide)";

export const commonDownloadStyle = `<style>
    img{max-height:400px; max-width:60%; margin:6px; display:block} 
    p{width:70%; word-break: break-all; margin-top:0px; margin-bottom:5px}
    h1,h2,h3,h4,h5,h6{margin-top:0px; margin-bottom:5px}
    li p{margin-top:0px}
</style>`;
export const commonNoImageStyle = `<style>img{display:none}</style>`;

export const formatQuestionHtmlForPDF = (htmlContent) => {
    // Regular expression to match and remove 'word-break' styles
    const wordBreakRegex = /word-break:\s*[^;"]+[;"]/g;
    // Regular expression to match and remove 'font-family' styles
    const fontFamilyRegex = /font-family:\s*[^;"]+[;"]/g;

    // Remove 'word-break' and 'font-family' styles
    let formattedContent = htmlContent.replace(wordBreakRegex, '');
    formattedContent = formattedContent.replace(fontFamilyRegex, '');

    return formattedContent;
};